/**
 * Fortschritt beim Zuordnen und Umhängen — jedes Foto wird in der Nextcloud verschoben,
 * das dauert. Der laufende Balken zeigt: die App arbeitet, sie hängt nicht.
 */
import type { Schritt } from "../../hooks/useMedien";

export default function Arbeitsfortschritt({ s, was }: { s: Schritt; was: string }) {
  const prozent = s.gesamt ? Math.max(4, Math.round((s.fertig / s.gesamt) * 100)) : 4;
  return (
    <div className="fo-fortschritt fo-arbeit" role="status" aria-live="polite">
      <div className="fo-fortschritt-kopf">
        <strong>{s.fertig} von {s.gesamt} {s.gesamt === 1 ? "Foto" : "Fotos"} {was}</strong>
        <span>Die Dateien werden in der Nextcloud verschoben.</span>
      </div>
      <div className="fo-balken is-laeuft" aria-hidden="true"><i style={{ width: `${prozent}%` }} /></div>
    </div>
  );
}
